/* Kollektionsseite: Schieberegler, Sortierung, Filterwechsel ohne Seitenwechsel
   (Section Rendering API) und Filterfelder im Bild halten. Bis 19.10.2026
   standen beide Bloecke als script in sections/msw-kollektion-raster.liquid.
   Geladen aus layout/msw-start.liquid mit defer, nur bei
   template.name == 'collection'. */
  (() => {
    // Die Sektion steckt in der JSON-Vorlage (templates/collection.json) und
    // heisst im DOM deshalb shopify-section-template--...__raster, nicht
    // shopify-section-msw-kollektion-raster. Mit der festen Kennung von
    // frueher fand das Skript nichts, und jeder Filterklick lud die ganze
    // Seite neu (gefunden 19.10.2026). Darum Kennung aus dem DOM und die
    // section_id fuer die Section Rendering API daraus ableiten.
    const wurzel0 = document.querySelector('.shopify-section.msw-kollektion-raster');
    if (!wurzel0) return;
    const KENNUNG = wurzel0.id;
    const SECTION_ID = KENNUNG.replace(/^shopify-section-/, '');

    // Das Skript sitzt in der Sektion, die es selbst austauscht. Beim Austausch
    // fuehrt der Browser das eingefuegte script-Tag nicht aus — trotzdem der
    // Riegel, falls die Sektion je zweimal auf einer Seite landet.
    if (window.__mswKollektion) return;
    window.__mswKollektion = true;

    const bereich = () => document.getElementById(KENNUNG);

    /* ---------------------------------------------------------------
       Schieberegler aus der Stufenliste bauen.

       Die Liste bleibt der Unterbau und wird nur versteckt. Ohne
       JavaScript ist jede Stufe ein normaler Link.
       --------------------------------------------------------------- */
    function reglerBauen(wurzel) {
      for (const feld of wurzel.querySelectorAll('[data-msw-regler]')) {
        if (feld.querySelector('.msw-regler')) continue;
        const liste = feld.querySelector('.filter_list');
        if (!liste) continue;

        const stufen = [...liste.querySelectorAll('a.filter_checkbox')].map(a => ({
          text: (a.querySelector('.filter_checkbox-lable') || a).textContent.replace(/\s+/g, ' ').trim(),
          ziel: a.getAttribute('href'),
          aktiv: a.classList.contains('is-active')
        }));
        if (stufen.length < 2) continue;

        // Position 0 heisst "Alle" — damit nimmt derselbe Griff den Filter
        // auch wieder weg.
        const punkte = [{ text: 'Alle', ziel: feld.getAttribute('data-msw-ohne'), aktiv: false }, ...stufen];
        const start = Math.max(0, punkte.findIndex(p => p.aktiv));

        const box = document.createElement('div');
        box.className = 'msw-regler';
        const wert = document.createElement('output');
        wert.className = 'msw-regler__wert';
        const regler = document.createElement('input');
        regler.type = 'range';
        regler.min = '0';
        regler.max = String(punkte.length - 1);
        regler.step = '1';
        regler.value = String(start);
        regler.setAttribute('aria-label', feld.getAttribute('data-msw-titel') || 'Auswahl');
        const enden = document.createElement('div');
        enden.className = 'msw-regler__enden';
        const links = document.createElement('span');
        links.textContent = 'Alle';
        const rechts = document.createElement('span');
        rechts.textContent = punkte[punkte.length - 1].text.replace(/\s*\(\d+\)\s*$/, '');
        enden.append(links, rechts);

        const zeige = i => {
          const p = punkte[i];
          const teile = p.text.match(/^(.*?)\s*(?:\((\d+)\))?$/);
          wert.textContent = teile ? teile[1] : p.text;
          if (teile && teile[2]) {
            const z = document.createElement('span');
            z.className = 'filter_treffer';
            z.textContent = ' (' + teile[2] + ')';
            wert.append(z);
          }
          regler.style.setProperty('--msw-anteil', (i / (punkte.length - 1)) * 100 + '%');
        };
        zeige(start);

        // Mit der Maus feuert "change" erst beim Loslassen, mit der Tastatur
        // bei jedem Pfeiltastendruck. Ohne Bremse waere der Regler mit der
        // Tastatur unbenutzbar. Ein Mausklick loest ueber pointerup sofort aus.
        let warten;
        const springe = () => {
          clearTimeout(warten);
          const p = punkte[Number(regler.value)];
          if (p && p.ziel) hole(p.ziel);
        };
        regler.addEventListener('input', () => zeige(Number(regler.value)));
        regler.addEventListener('change', () => {
          clearTimeout(warten);
          warten = setTimeout(springe, 450);
        });
        regler.addEventListener('pointerup', () => {
          if (Number(regler.value) !== start) springe();
        });

        box.append(wert, regler, enden);
        liste.hidden = true;
        feld.prepend(box);
      }
    }

    /* ---------------------------------------------------------------
       Sortierung: mit Skript sofort, ohne Skript ueber den Knopf.
       --------------------------------------------------------------- */
    function sortierungBauen(wurzel) {
      const form = wurzel.querySelector('[data-msw-sortform]');
      if (!form || form.dataset.mswFertig) return;
      form.dataset.mswFertig = '1';
      const knopf = form.querySelector('[data-msw-sortsenden]');
      if (knopf) knopf.hidden = true;
      form.addEventListener('submit', e => {
        e.preventDefault();
        const daten = new URLSearchParams(new FormData(form));
        hole(form.getAttribute('action') + '?' + daten.toString());
      });
      form.querySelector('select')?.addEventListener('change', () => form.requestSubmit
        ? form.requestSubmit()
        : form.dispatchEvent(new Event('submit', { cancelable: true })));
    }

    function aufbauen(wurzel) {
      reglerBauen(wurzel);
      sortierungBauen(wurzel);
    }

    /* ---------------------------------------------------------------
       Filterwechsel ohne Seitenwechsel.

       Shopify kann eine einzelne Sektion ausliefern (section_id). Statt die
       ganze Seite neu zu laden, holt das hier nur Filterspalte und Raster und
       tauscht sie aus. Der Kunde bleibt an der Stelle stehen, an der er
       gerade liest, statt oben auf der Seite zu landen.

       Faellt irgendetwas davon aus, wird ganz normal navigiert — die Links
       sind echte Links und funktionieren auch ohne dieses Skript.
       --------------------------------------------------------------- */
    let laeuft;
    async function hole(adresse, zurueck) {
      const alt = bereich();
      if (!alt || !adresse) return;

      // Welches Feld ist gerade offen? Nach dem Austausch soll es das wieder
      // sein, sonst klappt dem Kunden der Filter unter der Hand zu.
      const offenesFeld = alt.querySelector('details.filter_group[open] summary');
      const offenerName = offenesFeld ? offenesFeld.textContent.replace(/\s+/g, ' ').trim() : null;

      // Wer mit der Tastatur arbeitet, steht nach dem Austausch sonst wieder am
      // Seitenanfang: Das fokussierte Element wird mit ausgetauscht und der Fokus
      // faellt auf <body>. Deshalb merken, an welchem Regler der Kunde gerade war.
      const amRegler = document.activeElement;
      const reglerFeld = amRegler && amRegler.type === 'range'
        ? amRegler.closest('[data-msw-regler]')?.getAttribute('data-msw-titel')
        : null;

      if (laeuft) laeuft.abort();
      laeuft = new AbortController();
      alt.classList.add('msw-laedt');

      try {
        const u = new URL(adresse, location.origin);
        u.searchParams.set('section_id', SECTION_ID);
        const antwort = await fetch(u, { signal: laeuft.signal });
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        const text = await antwort.text();
        const neu = new DOMParser().parseFromString(text, 'text/html').getElementById(KENNUNG);
        if (!neu) throw new Error('Sektion nicht im Ergebnis');

        alt.replaceWith(neu);
        if (!zurueck) history.pushState({ msw: 1 }, '', adresse);

        if (offenerName) {
          for (const d of neu.querySelectorAll('details.filter_group')) {
            const s = d.querySelector('summary');
            if (s && s.textContent.replace(/\s+/g, ' ').trim() === offenerName) { d.open = true; break; }
          }
        }
        aufbauen(neu);

        // Fokus dorthin zurueck, wo der Kunde war.
        if (reglerFeld) {
          const feld = [...neu.querySelectorAll('[data-msw-regler]')]
            .find(f => f.getAttribute('data-msw-titel') === reglerFeld);
          feld?.querySelector('input[type="range"]')?.focus();
        } else if (offenerName) {
          neu.querySelector('details.filter_group[open] summary')?.focus();
        }

        // Rutscht die Filterleiste beim Kuerzen der Liste aus dem Bild, holt
        // dieser Sprung sie zurueck. Steht sie noch sichtbar, passiert nichts.
        const leiste = neu.querySelector('.filter_content');
        if (leiste) {
          const k = leiste.getBoundingClientRect();
          if (k.top < 0 || k.top > window.innerHeight - 80) {
            leiste.scrollIntoView({ block: 'start', behavior: 'auto' });
            window.scrollBy(0, -140);
          }
        }
      } catch (fehler) {
        if (fehler.name === 'AbortError') return;
        // Im Zweifel der normale Weg: Seite neu laden.
        window.location.href = adresse;
      } finally {
        laeuft = null;
        bereich()?.classList.remove('msw-laedt');
      }
    }

    // Alle Wege, auf denen sich die Auswahl aendert, laufen ueber hole().
    document.addEventListener('click', e => {
      const b = bereich();
      if (!b) return;
      const a = e.target.closest('a');
      if (!a || !b.contains(a)) return;
      if (a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      const passt = a.matches('a.filter_checkbox, .filter_active-tag, .filter_remove-active, .w-pagination-previous, .w-pagination-next')
        || a.closest('.filter_empty');
      if (!passt) return;
      e.preventDefault();
      hole(a.href);
    });

    // Preisfeld absenden, ohne die Seite zu wechseln.
    document.addEventListener('submit', e => {
      const b = bereich();
      const form = e.target;
      if (!b || !b.contains(form) || !form.matches('.filter-preis_wrapper')) return;
      e.preventDefault();
      const daten = new URLSearchParams();
      for (const [name, w] of new FormData(form)) if (String(w).trim() !== '') daten.append(name, w);
      hole(form.getAttribute('action') + (daten.toString() ? '?' + daten.toString() : ''));
    });

    window.addEventListener('popstate', () => hole(location.href, true));

    aufbauen(document);
  })();

  /* Filterfelder im Bild halten (05.10.2026). Jedes Feld klappt 350px breit ab
     seinem Knopf nach rechts auf. Wo der Knopf steht, haengt vom Umbruch der
     Filterleiste ab: am Desktop schob "Farbe" die Seite 41px zur Seite, auf dem
     iPad Pro quer "Marke" 12px, am 320er-Handy war jedes Feld breiter als der
     Schirm. Beim Oeffnen deshalb nachmessen, notfalls schmaler machen und nach
     links ruecken. Lauscht auf document, weil die Filter per hole() neu kommen. */
  (() => {
    const RAND = 8;
    document.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open) return;
      const feld = d.querySelector('.filter_inputs');
      if (!feld) return;
      feld.style.left = '';
      feld.style.maxWidth = '';
      feld.style.minWidth = '';
      feld.style.width = '';
      // Sichtbarer Bereich: Bildschirm, am Handy zusaetzlich die Filterleiste,
      // die selbst abschneidet (overflow) und schmaler ist als der Schirm.
      let links = RAND;
      let rechts = document.documentElement.clientWidth - RAND;
      for (let p = feld.parentElement; p && p !== document.body; p = p.parentElement) {
        if (getComputedStyle(p).overflowX === 'visible') continue;
        const pr = p.getBoundingClientRect();
        links = Math.max(links, pr.left);
        rechts = Math.min(rechts, pr.right);
        break;
      }
      const platz = rechts - links;
      if (feld.offsetWidth > platz) {
        // .filter_inputs traegt min-width: 350px. Nur max-width setzen reicht
        // nicht, und min-width:0 allein faellt auf die Breite der Pille zurück
        // (Preisfeld war am 320er nur 107px breit) -- deshalb alle drei.
        feld.style.minWidth = platz + 'px';
        feld.style.maxWidth = platz + 'px';
        feld.style.width = platz + 'px';
      }
      const r = feld.getBoundingClientRect();
      let schub = 0;
      if (r.right > rechts) schub = r.right - rechts;
      if (r.left - schub < links) schub = r.left - links;
      if (schub) feld.style.left = ((parseFloat(getComputedStyle(feld).left) || 0) - schub) + 'px';
    }, true);
  })();
